import SyncableModel from './SyncableModel';

export default class Species extends SyncableModel {
    static name = 'Species'

    _fillable = [
      'id', 'aliases', 'name',
      'created_at', 'updated_at',
      'synced_at', 'deleted_at'
    ]

    static endpoint = '/species'

    static syncOnly = true
}
